var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDialogViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#ECE9F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#E2DEEC",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0003 31.918C25.0918 31.918 22.59 30.1725 21.4798 27.668C22.59 25.1634 25.0918 23.418 28.0003 23.418C30.9088 23.418 33.4106 25.1634 34.5208 27.668C33.4106 30.1725 30.9088 31.918 28.0003 31.918ZM23.917 27.668C23.917 29.9222 25.7461 31.7513 28.0003 31.7513C30.2545 31.7513 32.0837 29.9222 32.0837 27.668C32.0837 25.4138 30.2545 23.5846 28.0003 23.5846C25.7461 23.5846 23.917 25.4138 23.917 27.668ZM26.7503 27.668C26.7503 26.9755 27.3079 26.418 28.0003 26.418C28.6928 26.418 29.2503 26.9755 29.2503 27.668C29.2503 28.3604 28.6928 28.918 28.0003 28.918C27.3079 28.918 26.7503 28.3604 26.7503 27.668Z",
    fill: "#402080",
    stroke: "#402080",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialogViewIcon);
export default __webpack_public_path__ + "static/media/dialog-view-icon.ec9474df0d2a0e8af3b4efda1b1b3174.svg";
export { ForwardRef as ReactComponent };